import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class UnitsInUsePromptService {
	private armedAfterDowntime = false;
	private pendingPresent = false;
	private readonly presentRequestsSubject = new Subject<void>();

	readonly presentRequests$ = this.presentRequestsSubject.asObservable();

	armAfterDowntimeResolve = (): void => {
		this.armedAfterDowntime = true;
	};

	consumeAfterDowntimeArm = (): boolean => {
		const armed = this.armedAfterDowntime;
		this.armedAfterDowntime = false;
		return armed;
	};

	requestPresent = (): void => {
		this.pendingPresent = true;
	};

	nudgePresent = (): void => {
		if (this.pendingPresent) {
			this.presentRequestsSubject.next();
		}
	};

	consumePendingPresent = (): boolean => {
		const pending = this.pendingPresent;
		this.pendingPresent = false;
		return pending;
	};
}
